import "date-fns";
import React from "react";
import Button from "@material-ui/core/Button";
import AutoComplete from "../../../components/AutoComplete/AutoComplete";
import { AddressInput } from "../../../components/FormInputs/FormInputs";
import { AddressInputs } from "../../../utils/Data/dataTexts";
import { fillForm, checkAddress } from "../../../utils/Functions/functions";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";

function ConsigneeAddress({ ...props }) {
  return (
    <>
      <div className="StepContainer FormWidth">
        <div className="FormTitleContainer">
          <p className="FormQuestion Column">
            {i18n.t("consigneeadr.label")}
            {(!props.order.delivery && props.order.destination === "") ||
            (!props.order.delivery && props.order.destination === null) ? (
              <>
                <br />
                <span className="WarningText">
                  {i18n.t("consigneeadr.warning1")}
                  <span className="Underlined">
                    {" "}
                    {i18n.t("consigneeadr.warning2")}
                  </span>
                </span>
              </>
            ) : null}
          </p>
        </div>

        <div className="ContainerHorizontal" style={{ alignItems: "center" }}>
          <AutoComplete
            style={{ flex: 1 }}
            onChange={(place) => {
              props.addItem("consigneeaddresses", fillForm(place));
            }}
          />
        </div>
        {props.consigneeAddresses.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <div className="AddressContainer MarginHorizontal">
                {AddressInputs.map((input, i) => {
                  return (
                    <AddressInput
                      label={input.label}
                      id={input.id}
                      value={item[input.id]}
                      onChange={(event) => {
                        props.handleItemChange(event, 0, "consigneeaddresses");
                      }}
                      style={{
                        flexBasis:
                          window.innerWidth > 600 ? input.width : "100%",
                      }}
                    />
                  );
                })}
              </div>
            </React.Fragment>
          );
        })}
      </div>

      <div className="NavigationContainer FormWidth">
        <Button
          onClick={() => props.handleBack()}
          className="TransparentWhite Medium"
        >
          {i18n.t("general.back")}
        </Button>
        {checkAddress(
          props.order.delivery,
          props.order.destination,
          props.order.consigneeaddresses[0]
        ) ? (
          <div className="ButtonContainer">
            <Button
              onClick={() => {
                if (props.loggedIn) {
                  props.handleNext(2);
                } else props.handleNext();
              }}
              className="TransparentWhite Medium"
            >
              {i18n.t("general.skip")}
            </Button>
            <Button
              onClick={() => {
                if (props.loggedIn) {
                  props.handleNext(2);
                } else props.handleNext();
              }}
              className="OldLace Medium"
            >
              {i18n.t("general.next")}
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default withTranslation()(ConsigneeAddress);
